__turbopack_context__.v({
  "focusRing": "shell-module__5YwTTq__focusRing",
  "footer": "shell-module__5YwTTq__footer",
  "footerBar": "shell-module__5YwTTq__footerBar",
  "main": "shell-module__5YwTTq__main",
  "plainList": "shell-module__5YwTTq__plainList",
  "shell": "shell-module__5YwTTq__shell",
});
